(function () {
  angular
    .module('kareo.ui.shared.modules.api.open-billing-tasks', [
      'kareo.ui.shared.modules.api.user.k-user-service',
      'kareo.environment',
      'kareo.featureSetAreas'
    ])
    .factory('openBillingTasksService', openBillingTasksService);

  openBillingTasksService.$inject = [
    '$http',
    '$q',
    'kUserService',
    'KareoEnvironment',
    'featureSet'
  ];


  function openBillingTasksService(
      $http,
      $q,
      kUserService,
      environment,
      featureSet
  ) {
    var svc = {};
    svc.getOpenBillingTasksSummary = getOpenBillingTasksSummary;
    return svc;
    // //////////////////////////////////////////////////////////////////////

    function loadServices() {
      return $q.all([
        kUserService.isRcmEmployee(),
        featureSet.load()
      ]);
    }

    function getOpenBillingTasksSummary() {
      return loadServices().then((responses) => {
        var queryParams = '';
        queryParams += 'isPM=' + !!environment.hideChrome + '&';
        queryParams += 'relaxedPermissionsFeature=' + !!responses[1]['dark-feature.billing-tasks-relaxed-platform-perm'] + '&';
        queryParams += 'isUserRCMEmployee=' + !!responses[0];

        return $http.get('/billing-tasks-ui/api/BillingTasks/Task/OpenBillingTasksSummary?' + queryParams).then((response) => {
          return response.data;
        });
      });
    }
  }
})();
